(function () {
  const SELECTOR_GALLERY = '.media-gallery--artweb-thumbs';
  const SELECTOR_THUMBS_SCROLL = '.media-gallery--artweb-thumbs .slideshow-controls__thumbnails-container';
  const DESKTOP_MIN = 750;

  function isDesktop() {
    return window.matchMedia(`(min-width:${DESKTOP_MIN}px)`).matches;
  }

  function getGallery() {
    return document.querySelector(SELECTOR_GALLERY);
  }

  function getThumbsScroller() {
    return document.querySelector(SELECTOR_THUMBS_SCROLL);
  }

  function isGalleryActiveInViewport(galleryEl) {
    if (!galleryEl) return false;
    const r = galleryEl.getBoundingClientRect();

    // "Ativa" quando a galeria está realmente no miolo da tela
    // (evita pegar scroll quando você já está saindo dela)
    const topGate = 120;
    const bottomGate = window.innerHeight - 120;

    return r.top < bottomGate && r.bottom > topGate;
  }

  function canConsumeScroll(scroller, deltaY) {
    if (!scroller) return false;

    const max = scroller.scrollHeight - scroller.clientHeight;
    if (max <= 2) return false; // não tem scroll interno

    const atTop = scroller.scrollTop <= 0;
    const atBottom = scroller.scrollTop >= (max - 1);

    if (deltaY > 0 && !atBottom) return true; // descendo e ainda tem thumbs
    if (deltaY < 0 && !atTop) return true;    // subindo e ainda tem thumbs
    return false;
  }

  function bindWheel() {
    if (window.__artwebWheelBound) return;
    window.__artwebWheelBound = true;

    window.addEventListener(
      'wheel',
      (e) => {
        if (!isDesktop()) return;

        const gallery = getGallery();
        const scroller = getThumbsScroller();

        if (!isGalleryActiveInViewport(gallery)) return;

        // Aqui é o ponto: independente de onde está o mouse,
        // se a galeria está ativa, o scroll geral vira scroll das thumbs.
        if (!canConsumeScroll(scroller, e.deltaY)) return;

        e.preventDefault();
        scroller.scrollTop += e.deltaY;
      },
      { passive: false }
    );
  }

  function init() {
    bindWheel();
  }

  document.addEventListener('DOMContentLoaded', init);

  // Re-inicializa quando Shopify troca DOM (variante, etc.)
  const obs = new MutationObserver(init);
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
